import { createSlice } from "@reduxjs/toolkit";
import { fetchShippingFeesThunk, updateShippingFeeThunk } from "./shippingFeesThunk";

const shippingFeeSlice = createSlice({
    name: "shippingFees",
    initialState: {
        items: [],
        loading: false,
        error: null
    },
    reducers: {},
    extraReducers: (builder) => {
        builder
            .addCase(fetchShippingFeesThunk.pending, (state) => {
                state.loading = true;
                state.error = null;
            })
            .addCase(fetchShippingFeesThunk.fulfilled, (state, action) => {
                state.loading = false;
                state.items = action.payload;
            })
            .addCase(fetchShippingFeesThunk.rejected, (state, action) => {
                state.loading = false;
                state.error = action.payload;
            })

            .addCase(updateShippingFeeThunk.pending, (state) => {
                state.loading = true;
                state.error = null;
            })
            .addCase(updateShippingFeeThunk.fulfilled, (state, action) => {
                state.loading = false;
                state.items = state.items.map((e) =>
                    e.countryCode === action.payload.countryCode ? action.payload : e
                );
            })
            .addCase(updateShippingFeeThunk.rejected, (state, action) => {
                state.loading = false;
                state.error = action.payload;
            });
    }
});

export default shippingFeeSlice.reducer;
